// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteModal_modal__3Fm1N","body":"DeleteModal_body__3Pedw","description":"DeleteModal_description__1eOhc","deleteButton":"DeleteModal_deleteButton__30aIS"};